import { render, staticRenderFns } from "./communityWgOrganization.vue?vue&type=template&id=30b50fde&scoped=true&"
import script from "./communityWgOrganization.vue?vue&type=script&lang=js&"
export * from "./communityWgOrganization.vue?vue&type=script&lang=js&"
import style0 from "./communityWgOrganization.vue?vue&type=style&index=0&id=30b50fde&prod&lang=less&scoped=true&"
import style1 from "./communityWgOrganization.vue?vue&type=style&index=1&id=30b50fde&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b50fde",
  null
  
)

export default component.exports